/**
 * Display-layer timezone. Storage is UTC everywhere; this is the only place
 * that turns an instant into a wall-clock reading, and it renders in the
 * company's configured zone rather than whatever zone the viewer's laptop is
 * set to — otherwise an admin in London sees a New York crew's 11pm shift as
 * 4am the next day.
 */
const KEY = "checkmate_company_tz";

export const setCompanyTz = (tz) => {
  if (tz) localStorage.setItem(KEY, tz);
};

export const companyTz = () =>
  localStorage.getItem(KEY) || Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

/** True once a company zone is actually known (not a browser-zone fallback). */
export const hasCompanyTz = () => !!localStorage.getItem(KEY);

const fmt = (iso, opts) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  try {
    return new Intl.DateTimeFormat(undefined, { timeZone: companyTz(), ...opts }).format(d);
  } catch {
    return new Intl.DateTimeFormat(undefined, opts).format(d);
  }
};

export const fmtDateTime = (iso) =>
  fmt(iso, { dateStyle: "short", timeStyle: "short" });

export const fmtDate = (iso) => fmt(iso, { dateStyle: "short" });

export const fmtTime = (iso) =>
  fmt(iso, { hour: "2-digit", minute: "2-digit" });

/** Short zone label for a column header, e.g. "EST" or "PDT". */
export const tzLabel = (iso) => {
  const d = iso ? new Date(iso) : new Date();
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: companyTz(), timeZoneName: "short",
    }).formatToParts(d).find((p) => p.type === "timeZoneName")?.value || "";
  } catch {
    return "";
  }
};
